import Page from './page';
import MasonryGrid from '../components/masonry-grid';
import EventsCalendar from '../components/events-calendar';
import CategoryTags from '../components/category-tags';
import AjaxPagination from '../components/ajax-pagination';
import categoryCarousel from '../modules/category-page-carousel';
import imagesLoaded from '../vendors/imagesloaded.min';
import inView from '../modules/viewport';
import background from '../modules/background';

const defaults = {};

export default class CategoryPage extends Page {

  constructor($context, options) {
    super($context, options);

    this.init();
  }

  init() {
    this.initModules();
    this.initMasonryGrid();
    this.initEventsCalendar();
    this.initCategoryTags();
    this.initAjaxPagination();
    this.initImagesLoaded();
  }

  initModules() {
    categoryCarousel();
  }

  initMasonryGrid() {
    this.masonryGrid = (MasonryGrid.initialize())[0];
  }

  initEventsCalendar() {
    this.eventsCalendar = (EventsCalendar.initialize())[0];
  }

  initCategoryTags() {
    this.categoryTags = (CategoryTags.initialize())[0];
  }

  initAjaxPagination() {
    this.ajaxPagination = (AjaxPagination.initialize())[0];

    if (this.ajaxPagination) {
      this.ajaxPagination.on('contentLoaded', () => {
        if (this.ajaxPagination.direction === 1) {
          this.masonryGrid.appended(this.ajaxPagination.$lastOutput);
        } else {
          this.masonryGrid.prepended(this.ajaxPagination.$lastOutput);
        }

        this.initImagesLoaded();
      });

      this.categoryTags.on('change', ({ target: subcategories }) => {
        this.ajaxPagination.setFilter({ subcategory: subcategories.join(',') });

        this.eventsCalendar.setFilter({ subcategory: subcategories.join(',') });
      });
    }
  }

  initImagesLoaded() {
    background();
    imagesLoaded('.grid-item').on('progress', () => {
      this.masonryGrid.refresh();
      inView();
    }).on('done', () => {
      this.masonryGrid.refresh();
      inView();
    });
  }

  static initialize(selector = 'body') {
    return super.initialize(selector, CategoryPage, 'CategoryPage');
  }

}



// WEBPACK FOOTER //
// ./front/bankomania/js/pages/category-page.js